import React from 'react';
import { Shield, Heart, Globe } from 'lucide-react';
import HoverText from './HoverText';

const Mission = () => {

  const values = [
    {
      icon: Shield,
      title: "Dauerhafter Schutz",
      description: "Wir kaufen bedrohte Waldgebiete und sichern sie langfristig vor Abholzung und Ausbeutung."
    },
    {
      icon: Heart,
      title: "Transparent und Seriös",
      description: "100% Ihrer Spende fliesst in den Waldkauf. Jeder Franken ist nachvollziehbar und wird dokumentiert."
    },
    {
      icon: Globe,
      title: "Globale Wirkung",
      description: "Von Regenwäldern bis zu heimischen Wäldern - wir schützen Biosphären weltweit."
    }
  ];

  return (
    <section id="mission" className="py-16 md:py-24 lg:py-32 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* REFACTORED: Flex Layout mit column auf Mobile, row auf Desktop */}
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-start">
          
          {/* Image - 40% auf Desktop, volle Breite auf Mobile */}
          <div className="w-full lg:w-5/12 relative group flex-shrink-0">
            <div className="absolute -inset-6 bg-gradient-to-r from-[#FF1B8D]/10 to-[#FF9B8C]/10 rounded-3xl blur-3xl group-hover:blur-[80px] transition-all duration-500"></div>
            <img
              src="https://images.unsplash.com/photo-1603346996604-cd77fc859e1d?crop=entropy&cs=srgb&fm=jpg&q=85"
              alt="Geschützter Wald"
              className="relative rounded-2xl md:rounded-3xl shadow-xl w-full h-[300px] md:h-[400px] lg:h-[500px] object-cover"
            />
          </div>

          {/* Content - 60% auf Desktop mit mehr Padding, volle Breite auf Mobile */}
          <div className="w-full lg:w-7/12 lg:pl-16">
            {/* Überschrift */}
            <HoverText 
              className="text-gray-900 mb-6 md:mb-8 font-bold" 
              style={{ 
                fontFamily: "'Playfair Display', serif", 
                fontSize: 'clamp(28px, 5vw, 42px)',
                lineHeight: 1.2,
                textAlign: 'left',
                marginBottom: 'clamp(24px, 4vw, 32px)'
              }}
            >
              Wo Wälder leben, finden Tiere und Pflanzen ihr Zuhause.
            </HoverText>
            
            {/* Fließtext - GRAU statt Pink, mit leading-relaxed */}
            <p className="text-slate-700 mb-4 leading-relaxed text-base md:text-lg">
              Wälder sind das Herz unseres Planeten. Sie produzieren Sauerstoff, speichern CO₂, sind Heimat für 80% aller Landtiere und Pflanzen - von Hirschen über Vögel bis zu Insekten. Ohne Wälder verlieren unzählige Tierarten ihr Zuhause.
            </p>
            
            <p className="text-slate-700 mb-6 md:mb-8 leading-relaxed text-base md:text-lg">
              Doch jede Minute verlieren wir Waldfläche in der Grösse von 40 Fussballfeldern. Trees Life Charity stoppt diese Zerstörung - wir kaufen bedrohte Wälder und schaffen sichere Lebensräume für Wildtiere.
            </p>

            {/* Values */}
            <div className="space-y-6 mt-8">
              {values.map((value, index) => {
                const Icon = value.icon;
                return (
                  <div key={index} className="flex items-start gap-4 group">
                    <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-gradient-to-br from-[#FF1B8D] to-[#FF9B8C] flex items-center justify-center shadow-md group-hover:shadow-lg group-hover:scale-110 transition-all duration-300" style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <Icon className="h-6 w-6 text-white" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-1 text-left">{value.title}</h3>
                      <p className="text-gray-600 leading-relaxed text-sm md:text-base text-left">{value.description}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Mission;
